import React from "react";
import { Link } from "react-router-dom";

/**
 * RETIRED diet-based apply. Exam applications are now made through Exam Calls
 * (apply -> pay -> finalize), so this modal no longer creates/submits an
 * application — it points the member to the open exam calls instead. Props are
 * kept so existing callers keep compiling.
 */
export default function ApplyExamModal({
  open,
  onClose,
  examTitle,
}: {
  open: boolean;
  onClose: () => void;
  dietId?: string;
  examId?: string;
  examTitle?: string;
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-white shadow-xl flex flex-col">
        <div className="p-4 border-b flex items-center justify-between gap-3">
          <div>
            <div className="text-sm text-gray-500">Apply for</div>
            <div className="text-lg font-semibold text-gray-900">{examTitle ?? "this exam"}</div>
          </div>
          <button
            onClick={onClose}
            className="px-3 py-2 rounded-lg border text-sm hover:bg-gray-50"
          >
            Close
          </button>
        </div>

        <div className="p-5 flex-1">
          <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
            <div className="font-semibold text-gray-900">Applications have moved</div>
            <p className="text-sm text-gray-600 mt-1">
              Exam applications are now made through <strong>Exam Calls</strong>. You'll check
              eligibility, pay the application fee, then choose your center and papers.
            </p>
            <Link
              to="/exams/calls"
              onClick={onClose}
              className="inline-block mt-4 px-4 py-2 rounded-lg bg-gray-900 text-white text-sm hover:bg-gray-800"
            >
              Go to Exam Calls
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
